import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getBrand = async (id: string) => {
    const { data, error } = await supabase
        .from('product_brand')
        .select(`*`)
        .eq('id', id)
        .single()

    if (error) {
        throw new Error(error.message)
    }

    return data
}

export default function useGetBrandById(id: string) {
    return useQuery({
        queryKey: ['useGetBrandById'],
        queryFn: () => getBrand(id),
        staleTime: 0,
        enabled: !!id,
    })
}
